import styles from './Coverage.module.css';

export type CoverageStatus = 'below' | 'above' | 'complete' | 'met';

export interface CoverageValue {
	percentage: number;
	status: CoverageStatus;
}

const STATUS_LABEL: Record<CoverageStatus, string> = {
	below: 'abaixo',
	above: 'acima',
	complete: 'completo',
	met: 'atendido',
};

const STATUS_TEXT_CLASS: Record<CoverageStatus, string> = {
	below: styles.statusOutlier,
	above: styles.statusOutlier,
	complete: styles.statusComplete,
	met: styles.statusMet,
};

export const CoverageBar = ({ percentage }: { percentage: number }) => (
	<div className={styles.track}>
		<div
			className={`${styles.fill} ${percentage > 100 ? styles.fillOver : styles.fillOk}`}
			style={{ width: `${Math.max(0, Math.min(percentage, 100))}%` }}
		/>
	</div>
);

export const CoveragePercentage = ({ value }: { value: CoverageValue }) => (
	<span className={`${styles.percentage} ${STATUS_TEXT_CLASS[value.status]}`}>
		{Math.round(value.percentage)}%
	</span>
);

export const CoverageStatusLabel = ({ status }: { status: CoverageStatus }) => (
	<span className={`${styles.statusLabel} ${STATUS_TEXT_CLASS[status]}`}>{STATUS_LABEL[status]}</span>
);
